@if(component){
<div class="flex-top flex flex-column p-t-5 p-b-5 p-t-4-s p-t-4-m p-b-4-s p-b-4-m">
    <div class="flex-column m-r-10-x m-r-10-l w-12">
        <text-box class="w-12 flex flex-middle"
                  [data]="component"></text-box>
        <div class="w-12 flex m-t-4">
            <!-- length -->
            <form-mui-field [label]="'Length'"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       [(ngModel)]="data.roomLength"
                       (ngModelChange)="calculateResult()"
                       name="length"
                       required />
            </form-mui-field>
            <div class="p1 m-l m-r m-l-2-s m-r-2-s m-l-2-m m-r-2-m flex flex-middle">x</div>
            <!-- width -->
            <form-mui-field [label]="'Width'"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       name="width"
                       [(ngModel)]="data.roomWidth"
                       (ngModelChange)="calculateResult()"
                       required />
            </form-mui-field>
            <div class="p1 m-l m-r m-l-2-s m-r-2-s m-l-2-m m-r-2-m flex flex-middle">x</div>
            <!-- height -->
            <form-mui-field [label]="'Height'"
                            class="w-4">
                <input class="bg-col-w"
                       type="number"
                       name="height"
                       [(ngModel)]="data.roomHeight"
                       (ngModelChange)="calculateResult()"
                       required />
            </form-mui-field>
        </div>
        <div class="m-t w-12 flex">
            <form-mui-field [label]="'Product Options'"
                            class="w-12">
                <select class="bg-col-w"
                        type="text"
                        name="productOptionId"
                        [(ngModel)]="data.productOptionId"
                        (ngModelChange)="calculateResult()"
                        required>
                    @for (option of productOptions; track option.id) {
                    <option [value]="option.id">
                        {{option.data?.thickness | optionLabel : 'thickness' }}
                    </option>
                    }
                </select>
            </form-mui-field>
        </div>
        <div class="m-t">
            <form-mui-field [label]="'Desired Reverberation Time'"
                            class="w-12">
                <select class="bg-col-w"
                        type="text"
                        name="reverbTime"
                        [(ngModel)]="data.reverbTime"
                        (change)="calculateResult()"
                        required>
                    @for (time of component.reverbTimes; track time) {
                    <option [value]="time.value">
                        {{ time.label }}
                    </option>
                    }
                </select>
            </form-mui-field>
        </div>
        <div class="m-t flex m-b flex-middle flex-column-s flex-column-m flex-top-s flex-top-m">
            <p class="col-1 m-r-2 p2">{{'Recommended Product Square Footage' | translate}}:</p>
            <span class="h3 col-3">{{result}} sq ft</span>
        </div>
    </div>
    <df-image-wrapper class="overflow-hidden m-t-4-s m-t-4-m b-a b-col-5 w-12"
                      style="border-radius: 12px;">
        <img [ratio]="component.ratio || '3/2'"
             [dfImage]="component.image">
    </df-image-wrapper>
</div>
}